import { faPen } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import { Tooltip } from 'govwell-ui'

import { navigate } from '@cedarjs/router'

type Props = {
  tooltip?: string
} & ({ href: string; onClick?: never } | { href?: never; onClick: () => void })
export const EditButton = (props: Props) => {
  const { href, onClick, tooltip } = props
  return (
    <Tooltip content={tooltip}>
      <Button
        icon={<FontAwesomeIcon icon={faPen} />}
        type="default"
        size="small"
        onClick={(e) => {
          e?.preventDefault()
          if (onClick) {
            onClick()
          } else {
            navigate(href)
          }
        }}
      />
    </Tooltip>
  )
}
